var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand-header"},[_c('img',{staticClass:"circular-logo",attrs:{"src":_vm.logo,"alt":_vm.name + ' logo'}}),_c('p',[_vm._v(_vm._s(_vm.name || 'Unknown brand')+" >")])])}
var staticRenderFns = []

export { render, staticRenderFns }